
import { RevLink, RevPitchBlock, openModal } from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'
import LoadInViewport from '@core/components/LoadInViewport'
import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { trackEcoBlockImpression } from '@tracking/events'

import RenewedImpactModal from '../Modals/RenewedImpactModal'

import translations from './EcoBlock.translations'
import { ECO_BLOCK_ICONS } from './ecoBlock.mocks'

export default {
  components: {
    RenewedImpactModal,
    RevLink,
    RevPitchBlock,
    LoadInViewport,
  },

  props: {
    layout: {
      type: String,
      required: false,
    },
    trackingInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    translations: () => translations,
    ecoBlockMocks() {
      return {
        cards: [
          {
            title: this.$t(translations.card1Title),
            description: this.$t(translations.card1Description),
            image: {
              alt: '',
              height: 150,
              src: this.$static(
                `/img/product/eco-block/${ECO_BLOCK_ICONS[0]}.svg`,
              ),
              width: 150,
            },
          },
          {
            title: this.$t(translations.card2Title),
            description: this.$t(translations.card2Description),
            image: {
              alt: '',
              height: 150,
              src: this.$static(
                `/img/product/eco-block/${ECO_BLOCK_ICONS[1]}.svg`,
              ),
              width: 150,
            },
          },
          {
            title: this.$t(translations.card3Title),
            description: this.$t(translations.card3Description),
            image: {
              alt: '',
              height: 150,
              src: this.$static(
                `/img/product/eco-block/${ECO_BLOCK_ICONS[2]}.svg`,
              ),
              width: 150,
            },
          },
          {
            title: this.$t(translations.card4Title),
            description: this.$t(translations.card4Description),
            image: {
              alt: '',
              height: 150,
              src: this.$static(
                `/img/product/eco-block/${ECO_BLOCK_ICONS[3]}.svg`,
              ),
              width: 150,
            },
          },
        ],
        subtitle: this.$t(translations.subtitle),
        title: this.$t(translations.title),
        link: {
          text: this.$t(translations.modalLinkText),
        },
      }
    },
  },

  mounted() {
    this.unobserve = this.watchInViewport()
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  methods: {
    handleModalOpen() {
      openModal(MODAL_NAMES.PRODUCT.RENEWED_IMPACT)
    },

    watchInViewport() {
      return createObserver(this.$el, () => {
        trackEcoBlockImpression({
          pageType: 'product',
          ...this.trackingInfo,
        })
      })
    },
  },
}
